import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class FaultDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"FAUTE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "FAUTE",
            player: event.detail?.player,
            opponent: event.detail?.opponent,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    get opponent() {
        return this.detail.opponent;
    }
    set opponent(value) {
        this.detail.opponent = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player", "opponent"].includes(key)){
            let commentaire = "Faute"

            const faultPlayer = getPlayer(this.player, match)
            const opponentPlayer = getPlayer(this.opponent, match)
            const team = getTeam(this.team, match)

            if(this.player){
                if(faultPlayer){
                    commentaire += ' de '+ faultPlayer.lastname
                }
            }else if(team){
                commentaire += ' de '+ team.name
            }

            if(this.opponent){
                if(opponentPlayer){
                    commentaire += ' sur '+ opponentPlayer.lastname
                }
            }

            commentaire += "! "

            

            this.text = commentaire
        }
    }
}